/* eslint-disable import/prefer-default-export */
export function isRetina() {
  if (typeof window !== "undefined") {
    return window.devicePixelRatio > 1;
  }

  // Default to non-retina when SSR render
  return false;
}
